var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86914 0H42.8066C47.8004 0 51.8379 4.05983 51.8379 9.0812V40.9188C51.8379 45.9402 47.8004 50 42.8066 50H9.86914C4.87539 50 0.837891 45.9402 0.837891 40.9188V9.0812C0.837891 4.05983 4.87539 0 9.86914 0Z",
    fill: "#330000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4883 29.9146H17.5833L15.9683 34.936C15.9258 35.1283 15.7558 35.2565 15.5645 35.2351H11.5695C11.3358 35.2351 11.272 35.1069 11.3358 34.8505L18.1783 15.0428C18.242 14.8292 18.3058 14.5941 18.3908 14.3377C18.4758 13.889 18.5183 13.4189 18.5183 12.9488C18.497 12.842 18.582 12.7351 18.6883 12.7138H24.192C24.362 12.7138 24.447 12.7779 24.4683 12.8847L32.2245 34.8933C32.2883 35.1283 32.2245 35.2351 32.012 35.2351H27.5708C27.422 35.2565 27.2733 35.1497 27.2308 35.0001L25.4883 29.9146ZM18.8158 25.577H24.2133C24.0858 25.1283 23.9158 24.5941 23.7245 24.0386C23.5333 23.4616 23.342 22.842 23.1508 22.201C22.9383 21.5386 22.747 20.8975 22.5345 20.2351C22.322 19.5727 22.1308 18.9531 21.9608 18.3334C21.7908 17.7351 21.642 17.1796 21.4933 16.6668H21.4508C21.2595 17.5856 21.0258 18.5044 20.7283 19.4232C20.4095 20.4488 20.0908 21.5172 19.7508 22.5856C19.4533 23.6753 19.1345 24.6796 18.8158 25.577ZM36.9633 16.4531C36.262 16.4745 35.582 16.1967 35.072 15.7052C34.5833 15.171 34.3283 14.4659 34.3495 13.7394C34.3283 13.0129 34.6045 12.3292 35.1145 11.8377C35.6245 11.3463 36.3045 11.0898 37.0058 11.0898C37.8345 11.0898 38.472 11.3463 38.9395 11.8377C39.407 12.3505 39.662 13.0343 39.6408 13.7394C39.662 14.4659 39.407 15.171 38.897 15.7052C38.4083 16.218 37.6858 16.4958 36.9633 16.4531ZM34.5833 35.0001V18.5471C34.5833 18.3334 34.6683 18.248 34.8595 18.248H39.067C39.2583 18.248 39.3433 18.3548 39.3433 18.5471V35.0001C39.3433 35.2351 39.2583 35.342 39.067 35.342H34.902C34.6895 35.342 34.5833 35.2138 34.5833 35.0001Z",
    fill: "#FF9A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 50,
    fill: "white",
    transform: "translate(0.837891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.3f6ac7c074fefbf7eb6a06536aba9c9e.svg";
export { ForwardRef as ReactComponent };